var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ProjectInfo from '../home/ProjectInfo.vue';
import Cta from '../shared/Cta.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let Project = class Project extends Vue {
    mounted() {
        window.cibbic.lazyLoadInstance.update();
    }
    onProjectLoaded() {
    }
    get sectors() {
        return this.project && this.project.sector ? this.project.sector.map(function (sector) {
            return sector.title;
        }).join(", ") : "";
    }
};
__decorate([
    Prop({ type: Object })
], Project.prototype, "labels", void 0);
__decorate([
    Prop()
], Project.prototype, "project", void 0);
__decorate([
    Watch('project')
], Project.prototype, "onProjectLoaded", null);
Project = __decorate([
    Component({
        components: {
            ProjectInfo,
            Cta
        }
    })
], Project);
export default Project;
